import { bankInfoComponent } from './bankInfo.component';

export const bankInfoStateName = 'app.bankInfo';

export const bankInfoState = ($stateProvider) => {
  'ngInject';
  $stateProvider.state({
    name: bankInfoStateName,
    url: '/bankenInformationen',
    data: { requiresAuth: true },
    component: bankInfoComponent.name,
  });
};
